import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { CustomMultiSelectField } from '@/components/shared/components/NewContextForms/shared/CustomMultiSelectField';
import { CustomTextFieldProps } from '@/components/shared/components/NewContextForms/shared/CustomTextField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { ReadOnlyMultipleValuesDataRow } from '@/components/shared/components/ReadOnlyMultipleValuesDataRow';
import { SelectOption } from '@/types/selectOption';

export interface SelectFormFieldProps<TFieldValues extends FieldValues> extends CustomTextFieldProps<TFieldValues> {
  name: FieldPath<TFieldValues>;
  value?: string[];
  dummyField?: boolean;
  selectOptions: SelectOption[];
}

export function MultiSelectFormField<T extends FieldValues>({
  name,
  dummyField = false,
  ...props
}: SelectFormFieldProps<T>) {
  const formControl = useFormContext()?.control;

  if (!formControl || dummyField)
    return props.fieldVariant === FieldVariant.form ? (
      <CustomMultiSelectField disabled={true} {...props} />
    ) : (
      <ReadOnlyMultipleValuesDataRow label={props.label} valuesArray={props.value} />
    );

  return (
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomMultiSelectField {...props} field={field} fieldVariant={FieldVariant.form} error={error} />
      )}
    />
  );
}
